export default __webpack_public_path__ + "static/media/proposal-rejected.d8d243f6.svg";